const U = (id, w = 1400) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=75`;
const AI = "https://static.prod-images.emergentagent.com/jobs/644a24b7-3616-43ac-a1eb-d561d221eb4c/images/";

export const IMG = {
  hero: `${AI}afc49fd42dfeb1da10f3968d3926791266f03d3fee4e65f2587298980225ddb4.jpeg`,
  parent: `${AI}a5eb948d12151d69edc28d70ba145720a9c2a60f61a9a318a5419c11cbc2e4aa.jpeg`,
};

export const SPORTS = [
  { id: "soccer", en: "Soccer", bg: "Футбол", tag: "Technique · 1v1 · Finishing", img: U("photo-1770237711068-6aebf8e5d591") },
  { id: "basketball", en: "Basketball", bg: "Баскетбол", tag: "Shooting · Handles · IQ", img: U("photo-1608245449230-4ac19066d2d0") },
  { id: "american-football", en: "American Football", bg: "Американски футбол", tag: "QB · WR · Speed", img: U("photo-1488474739786-757973c2dff6") },
  { id: "baseball", en: "Baseball", bg: "Бейзбол", tag: "Hitting · Pitching · Fielding", img: U("photo-1624375664562-fff61869fe8f") },
  { id: "softball", en: "Softball", bg: "Софтбол", tag: "Fastpitch · Defense · Batting", img: `${AI}ca56a65edada2d805d073345943260a2a8ff1c46ac6cef72efba6ed3877a7f71.jpeg` },
  { id: "pilates", en: "Pilates", bg: "Пилатес", tag: "Reformer · Core · Mobility", img: U("photo-1717500251716-27057c48ace4") },
  { id: "fitness", en: "Fitness / Personal Training", bg: "Фитнес / Персонален треньор", tag: "Fat loss · Muscle · Energy", img: U("photo-1758875569414-120ebc62ada3") },
  { id: "strength", en: "Strength & Conditioning", bg: "Сила и кондиция", tag: "Power · Speed · Injury-proof", img: U("photo-1533681904393-9ab6eee7e408") },
  { id: "tennis", en: "Tennis", bg: "Тенис", tag: "Serve · Footwork · Match play", img: U("photo-1554068865-24cecd4e34b8") },
  { id: "padel", en: "Padel", bg: "Падел", tag: "Walls · Volleys · Tactics", img: `${AI}e254d528adc1bea507c4574737c6a402cd2b760f81b9f8b9d31db40561f698e7.jpeg` },
];

export const sportById = (id) => SPORTS.find((s) => s.id === id);
export const sportName = (id, lang) => { const s = sportById(id); return s ? (lang === "bg" ? s.bg : s.en) : id; };
export const AGE_GROUPS = [
  { id: "kids", en: "Kids (5–12)", bg: "Деца (5–12)" },
  { id: "teens", en: "Teens (13–17)", bg: "Тийнейджъри (13–17)" },
  { id: "adults", en: "Adults (18+)", bg: "Възрастни (18+)" },
  { id: "seniors", en: "Seniors (60+)", bg: "60+" },
];
export const fmtMoney = (amount, currency) => {
  const c = (currency || "USD").toUpperCase();
  const n = Number(amount || 0);
  return `${c === "EUR" ? "€" : "$"}${n % 1 === 0 ? n : n.toFixed(2)}`;
};

